import React, { Dispatch } from 'react';
import { createContext, useContext, useContextSelector } from 'use-context-selector';
import { IScrollActions, IScrollState } from './ScrollPositionContext.types';
import scrollPositionReducer, { initialState } from './ScrollPositionContext.reducer';

export const ScrollPositionStateContext = createContext<IScrollState>(initialState);
export const ScrollPositionDispatchContext = createContext<Dispatch<IScrollActions>>(() => null);

export const useScrollPositionDispatch = () => useContext(ScrollPositionDispatchContext);
export const useScrollPositionSelector = <K extends keyof IScrollState>(
  selector: (state: IScrollState) => IScrollState[K]
) => useContextSelector<IScrollState, IScrollState[K]>(ScrollPositionStateContext, selector);

interface IScrollPositionStateProvider {
  children: React.ReactNode;
}

const ScrollPositionStateProvider = ({ children }: IScrollPositionStateProvider) => {
  const [state, dispatch] = React.useReducer(scrollPositionReducer, initialState);

  return (
    <ScrollPositionStateContext.Provider value={state}>
      <ScrollPositionDispatchContext.Provider value={dispatch}>
        {children}
      </ScrollPositionDispatchContext.Provider>
    </ScrollPositionStateContext.Provider>
  );
};

export default ScrollPositionStateProvider;
